@if (option()) {
	<div
		class="select-option"
		[ngClass]="{
			'select-option-disabled': option()!.isDisabled,
			'select-option-selected': selected(),
			'select-option-focused': focused(),
		}"
		(click)="emitSelectedOption()"
		[attr.data-cy]="'select-option'"
		[attr.data-cy-2]="'select-option-' + selected() ? 'selected' : 'not-selected'"
		[uiTooltip]="option()!.tooltip ?? ''"
	>
		@if (multiEnabled()) {
			<ui-checkbox
				class="select-option-checkbox"
				[ngClass]="{ 'select-option-icon': option()!.icon }"
				[checked]="selected()"
				[disabled]="option()!.isDisabled ?? false"
				(checkedChange)="emitSelectedOption()"
			>
			</ui-checkbox>
		}

		@if (customOptionTemplate() && customOptionTemplate()!.templateRef) {
			<ng-container
				*ngTemplateOutlet="customOptionTemplate()!.templateRef; context: { $implicit: option() }"
			></ng-container>
		} @else {
			@if (option()!.icon) {
				<ui-icon class="-ml-2 mr-1" [icon]="option()!.icon"></ui-icon>
			}
			<span
				class="select-option-title text-ellipsis overflow-hidden truncate"
				[class.text-ellipsis]="!fullWidth()"
			>
				{{ option()!.title }}
			</span>

			@if (option()!.pillText) {
				<div>
					<ui-pill
						[value]="option()!.pillText"
						[disabled]="option()!.isDisabled ?? false"
						type="secondaryOutline"
					></ui-pill>
				</div>
			}
		}
	</div>
}
